import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.knowyourpolicy.insure";
const DEFAULT_OG = `${SITE_URL}/og-image.png`;
const DEFAULT_TITLE =
  "KnowYourPolicy.ai — Understand your Indian motor insurance in plain English";
const DEFAULT_DESCRIPTION =
  "KnowYourPolicy.ai explains your Indian motor insurance policy in plain English — what's covered, what's excluded, and the clauses that can get a claim rejected. Free, 2 minutes, any insurer.";

/**
 * Route-level SEO tags. All values are optional; each defaults to the site-wide
 * copy set in public/index.html. `path` should start with "/" and is used to
 * build a canonical URL against the production origin.
 */
export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  noindex = false,
}) {
  const fullTitle = title ? `${title} · KnowYourPolicy.ai` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESCRIPTION;
  const canonical = `${SITE_URL}${path === "/" ? "/" : path.replace(/\/+$/, "")}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large" />
      )}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
